import { HierarchyUtils, TransformUtils, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { getUprights } from "./sectionsHelpers";
import { getTemplateDataComponent } from "@inter-ikea-storagetwo/range/dist/functions/componentGetters";
/**
 * Selects all root mounting rails, and then their descendants, resulting in all mounting rails in a room.
 *
 * @param core
 */
export const getBoaxelSolutions = (core) => getRootMountingRails(core).map(getDescendingMountingRails);
/**
 * Selects all mounting rails that are descendants of the mounting rail passed to it, including itself. If the
 * first mounting rail of a solution is passed as an argument, all mounting rails in a solution is selected.
 *
 * @param mountingRail
 */
export const getDescendingMountingRails = (mountingRail) => [
    mountingRail,
    ...HierarchyUtils.getDescendantsWithComponent(mountingRail, COMPONENT_IDS.MOUNTING_RAIL_COMPONENT),
];
/**
 * Selects all mounting rails in room that hasn't got an upright as parent
 *
 * @param core
 */
export const getRootMountingRails = (core) => HierarchyUtils.getDescendantsWithComponent(core.services.sceneManager.scene, COMPONENT_IDS.MOUNTING_RAIL_COMPONENT).filter((mountingRail) => {
    var _a;
    return !((_a = HierarchyUtils.parent(mountingRail)) === null || _a === void 0 ? void 0 : _a.hasComponent(COMPONENT_IDS.UPRIGHT_COMPONENT));
});
export const getUprightsInSolution = (mountingRails) => {
    const uprights = mountingRails.reduce((alreadyFoundUprights, mountingRail) => {
        const { leftUpright, rightUpright } = getUprights(mountingRail);
        const newlyFoundUprights = [leftUpright, rightUpright]
            .filter((candidateUpright) => !!candidateUpright)
            .filter((candidateUpright) => !alreadyFoundUprights.find((alreadyFoundUpright) => alreadyFoundUpright.id === candidateUpright.id));
        return [...alreadyFoundUprights, ...newlyFoundUprights];
    }, []);
    return uprights;
};
/**
 * Retrieves the size of a given entity based on its template data component.
 *
 * @param {Entity} entity - The entity for which to get the size.
 * @returns {Vector} The size of the entity.
 */
export const getEntitySize = (entity) => getTemplateDataComponent(entity).size;
/**
 * Retrieves the width of a given entity based on its template data component.
 * Not for mounting rails, use getRightUprightsOffsetFromLeft instead.
 *
 * @param {Entity} entity - The entity for which to get the width.
 * @returns {number} The width of the entity.
 */
export const getWidthOfEntity = (entity) => getTemplateDataComponent(entity).size.X;
/**
 * Takes the mounting rail entities of a solution and calculates the width of the solution.
 *
 * @param mountingRails
 */
export const getWidthOfSolution = (mountingRails) => {
    const uprights = getUprightsInSolution(mountingRails);
    if (uprights.length < 2)
        return 0;
    const uprightPositions = uprights.map((upright) => TransformUtils.worldPosition(upright));
    const { X: x1, Y: y1, Z: z1 } = uprightPositions[0];
    const { X: x2, Y: y2, Z: z2 } = uprightPositions[uprightPositions.length - 1];
    const distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2) + Math.pow(z2 - z1, 2));
    return distance;
};
